import React, { useEffect, useState } from 'react'
import PartyInvoiceDataGrid from './PartyInvoiceDataGrid'
import api from '../../utils/api'
import axios from 'axios'
import ReactTableInvoiceGrid from './ReactTableInvoiceGrid'
import { toast } from 'react-toastify'
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import { Button } from '../../common/Button/Button'
import Modal from "react-modal";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import { ControlledInput } from "../../common/Input/Input";
import Spinner from '../../common/Spinner/Spinner'





const PartyInvoiceMainContainer = () => {

    const [data, setData] = useState()
    // const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [extPartnerList, setExternalPartnerList] = useState()
    const [selectedExtPartner, setSelectedExtPartner] = useState(null)
    const [fromDate, setfromDate] = useState();
    const [toDate, settoDate] = useState();




    //  React Table Data Grid
    const [pages, setPages] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setcurrentPage] = useState(0);
    const [tableInstance, setTableInstance] = useState(null);
    const [count, setCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isFilterTrue, setIsFilterTrue] = useState(false)
    const [pageSizeOptions, setpageSizeOptions] = useState([
        {
            value: "10",
            label: "10 Rows",
        },
        {
            value: "20",
            label: "20 Rows",
        },
        {
            value: "30",
            label: "30 Rows",
        },
        {
            value: "50",
            label: "50 Rows",
        },
        {
            value: "75",
            label: "75 Rows",
        },
        {
            value: "100",
            label: "100 Rows",
        },
    ]);
    const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
        value: "10",
        label: "10",
    });

    const [selectedServiceRequests, setSelectedServiceRequests] = useState([]);


    // Modal Settle Payment
    const [paymentModal, setPaymentModal] = useState(false)
    const [invoiceDate, setInvoiceDate] = useState()
    const [invoiceDetails, setInvoiceDetails] = useState({
        invoiceNumber: "",
        transactionDetails: "",
        notes: "",
    })

    const openPaymentModalisTrue = () => {
        setPaymentModal(true)
    }

    const openPaymentModalisFalse = () => {
        setPaymentModal(false)
    }

    const onDateChange = (date) => {
        setInvoiceDate(date)
    }

    const onInvoiceDetailsChange = (key, value) => {
        if (key === "invNo") {
            setInvoiceDetails({ ...invoiceDetails, invoiceNumber: value });
        } else if (key === "details") {
            setInvoiceDetails({ ...invoiceDetails, transactionDetails: value });
        } else if (key === "notes") {
            setInvoiceDetails({ ...invoiceDetails, notes: value });
        }
    }

    const onSettleButtonClick = () => {
        const instanceIds = []
        if (selectedServiceRequests.length > 0) {
            selectedServiceRequests.map((ele) => {
                instanceIds.push(ele.nResourceInstanceId)
            })
        }

        console.log("Ids", instanceIds)

        if (!invoiceDate) {
            toast("Invoice Date not Provided", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        } else if (!invoiceDetails.invoiceNumber) {
            toast("Invoice Number not Provided", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        } else if (!invoiceDetails.transactionDetails) {
            toast("Transaction Details not Provided", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        } 
        else {
            let payload = {
                sInvoiceNumber: invoiceDetails.invoiceNumber,
                dtInvoiceDate: dateAdjusted1(invoiceDate),
                sTransactionId: invoiceDetails.transactionDetails,
                sRemark: invoiceDetails.notes,
                nResourceInstanceId: instanceIds,
                // sPaymentMode:selectedServiceRequests[0]["sPaymentMode"]
            }
            setIsLoading(true)
            setPaymentModal(false)
            const { tempSettlement } = api.updateSettlementInvoice(payload)
                .then(({ data }) => {
                    if (data.Result === 'Success') {
                        console.log("Payload", payload)
                        toast("Invoice Settled Successfully", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        setIsLoading(false)
                        setInvoiceDetails({
                            invoiceNumber: "",
                            transactionDetails: "",
                            notes: ""
                        })
                        setInvoiceDate()
                        getNewData(tableInstance, true)
                        setSelectedServiceRequests([])
                    } else {
                        toast("Something went wrong. Please contact Deasra Representative.", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                }).catch((error) => {
                    console.log(error)
                    toast("Internal Server Error", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
                )

            // gridRef.current.api.deselectAll();
        }

    }



    const getNewData = async (instance, flag = false) => {
        if (!instance) return;
        if (!tableInstance) setTableInstance(instance);

        try {
            const { page } = instance.state ?? { page: 0 };
            let icurrentPage = page;
            if (!flag && isNaN(icurrentPage)) return;
            const pageSize = selectedPageSizeOption.value;

            if (flag || isNaN(icurrentPage)) {
                icurrentPage = 0;
            }


            let filterParameters = {
                page: icurrentPage + 1,
                page_size: pageSize,
                // pagination: true,
                // SP_email: 'archana.sapre@mailinator.com'
            };

            // if (currentPage != icurrentPage) {
            //     setSelectedServiceRequests([]);
            // }

            if (fromDate) {
                filterParameters.from_date = dateAdjusted1(fromDate);
            }

            if (toDate) {
                filterParameters.to_date = dateAdjusted(toDate);
            }
            if (selectedExtPartner) {
                filterParameters.SP_email = selectedExtPartner.value;
            }
            setIsLoading(true);
            const { tempServices } = api.getServiceForSettlement(filterParameters).then(({ data }) => {
                setIsLoading(false);
                if (data) {
                    const { results, count } = data;
                    setcurrentPage(icurrentPage);
                    const totalPages = (count - 1) / pageSize + 1;
                    setCount(count);
                    setPages(Math.floor(totalPages));
                    setPageSize(pageSize);
                    setData(results);
                }
                else {
                    toast("Something went wrong. Please contact Deasra Representative.", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            })
        } catch (error) {
            setIsLoading(false);
            console.log(error)
            toast("Internal Server Error", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }

    }

    const fetchServiceRequests = (instance, flag) => {
        getNewData(instance, flag);
    };

    const getServiceIDs = () => {
        console.log("Selected", selectedServiceRequests)
    }


    const ondatechange = (key, date) => {
        if (key === "fromDate") {
            setfromDate(date)

        } else if (key === "toDate") {
            settoDate(date)

        }
    };



    const dateAdjusted = (date) => {
        let toDateAdjusted;
        if (date) {
            toDateAdjusted = new Date(date);

            toDateAdjusted = new Date(
                toDateAdjusted.setTime(
                    // toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
                    toDateAdjusted.getTime() + (29.5 * 60 * 60 * 1000 - 1000)
                )
            );
        }
        return toDateAdjusted;
    }

    const dateAdjusted1 = (date) => {
        let toDateAdjusted;
        if (date) {
            toDateAdjusted = new Date(date);

            toDateAdjusted = new Date(
                toDateAdjusted.setTime(
                    // toDateAdjusted.getTime() + ((6 * 60 * 60 * 1000) - (0.5 * 60 * 60 * 1000)) 
                    toDateAdjusted.getTime() + (5.5 * 60 * 60 * 1000)
                )
            );
        }
        return toDateAdjusted;
    }

    const onExtPartnerChange = (option) => {
        setSelectedExtPartner(option)
    }

    const onSearchClick = () => {
        if (!fromDate) {
            toast("Please Select From Date", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        } else if (!toDate) {
            toast("Please Select To Date", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        } else if (!selectedExtPartner) {
            toast("Please Select Service Partner", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        } else {
            console.log("Selected Partner =>", fromDate, toDate)
            getNewData(tableInstance, true)
            setIsFilterTrue(true)
        }

    }

    const onClearClick = () => {
        setSelectedExtPartner(null)
        setfromDate()
        settoDate()
        setIsFilterTrue(false)
        setData()
    }

    const yourFunctionToUpdatePage = (page) => {
        // Your logic to handle the page change goes here
        console.log('Current Page:', page);
        // You can set the page number to your desired state or perform other actions.
    };

    useEffect(() => {
        getNewData(tableInstance, true)
        const { tempPartnerListApi } = api.allExtPartnerList()
            .then(({ data }) => {
                const filteredPartnerList = data.filter(
                    (ele) => ele.sServicePartnerEmail !== null && ele.sServicePartnerEmail !== ""
                );

                const formattedData = filteredPartnerList.map((partner) => ({
                    value: partner.sServicePartnerEmail,
                    label: partner.sServicePartnerEmail,
                }));
                console.log("Ext Partner List>", formattedData)
                setExternalPartnerList(formattedData)
            }).catch(error => console.log(error))
    }, [selectedPageSizeOption])



    //  const getData = () => {
    //   const {tempPartnerListApi} = api.allExtPartnerList()
    //   .then(({data}) => {
    //     const filteredPartnerList = data.filter(
    //       (ele) => ele.sServicePartnerEmail !== null && ele.sServicePartnerEmail !== ""
    //     );

    //     const formattedData = filteredPartnerList.map((partner) => ({
    //       value: partner.sServicePartnerEmail,
    //       label: partner.sServicePartnerEmail,
    //     }));
    //     console.log("Ext Partner List>", formattedData)
    //     setExternalPartnerList(formattedData)
    //   }).catch(error => console.log(error))


    //   axios.get(`https://stagewebadmin.deasra.in:8050/server/service-request/?page=${currentPage}&page_size=50&pagination=true`, {
    //     headers: {
    //       Authorization: "Token 11c2e5f0fc3aa6e71c5c5fc5211bd3ce692829a3"
    //     }
    //   })
    //     .then(({ data }) => {
    //       setData(data.results)
    //       setTotalPages(Math.ceil(data.count / 10));
    //     })
    // }

    // useEffect(() => {
    //   getData()
    // }, [])

    return (
        <div className={`${isLoading && "set-opacity"}`}>
            {isLoading && <Spinner className="center-screen" />}
            <div>
                <Modal isOpen={paymentModal}>
                    <ModalContent className="general-modal">
                        <div className="modal-header">
                            <span className="modal-title">Settle Payment</span>
                            <img
                                alt="close"
                                id="Close"
                                src={close_modal}
                                className="close modal-close"
                                onClick={openPaymentModalisFalse}
                            />
                        </div>

                        <div className="modal-body">
                            <br />
                            <div className="row">
                                <div className="col-6 spled-container conv-zindex">
                                    <div className="width-100">
                                        <label style={{ marginBottom: "10px" }}>Invoice Date <span className="required">*</span></label><br />
                                        <ReactDatePicker
                                            dateFormat="dd/MM/yyyy"
                                            selected={invoiceDate}
                                            onChange={(date) => onDateChange(date)}
                                            placeholderText="Invoice Date"
                                            minDate={new Date(fromDate)}
                                            maxDate={new Date(toDate)}
                                        />
                                    </div>
                                </div>
                                <div className="col-6 spled-container">
                                    <div className="width-100">
                                        <label style={{ marginBottom: "10px" }}>Invoice No. <span className="required">*</span></label><br />
                                        <ControlledInput
                                            name="invoiceNumber"
                                            placeholder="Party Invoice No."
                                            value={invoiceDetails.invoiceNumber || ''}
                                            onChange={(e) => onInvoiceDetailsChange("invNo", e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-1 mb-2">
                                <div className="col-12 spled-container">
                                    <div className="width-100">
                                        <label style={{ marginBottom: "10px" }}>Transaction Details </label><span className="required">*</span><br />
                                        <input
                                            className='form-control'
                                            onKeyDown={(e) => {
                                                const isValidInput = /^[a-zA-Z0-9\s\.,?]+$/i.test(e.key);

                                                if (!isValidInput) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            type="text"
                                            name="details"
                                            placeholder="Transaction Details"
                                            value={invoiceDetails.transactionDetails || ''}
                                            onChange={(e) => onInvoiceDetailsChange("details", e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-1 mb-2">
                                <div className="col-12 spled-container">
                                    <div className="width-100">
                                        <label style={{ marginBottom: "10px" }}>Notes / Remarks </label><br />
                                        <input
                                            className='form-control'
                                            onKeyDown={(e) => {
                                                const isValidInput = /^[a-zA-Z0-9\s\.,?]+$/i.test(e.key);

                                                if (!isValidInput) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            type="text"
                                            name="notes"
                                            placeholder="Notes/ Remarks"
                                            value={invoiceDetails.notes || ''}
                                            onChange={(e) => onInvoiceDetailsChange("notes", e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='row d-flex justify-content-center align-items-center'>
                                <div className="offset-1 col-5">
                                    <Button className="esp-inline-button" onClick={onSettleButtonClick}>Settle</Button>
                                </div>
                            </div>

                        </div>
                    </ModalContent>
                </Modal>


                {/* <PartyInvoiceDataGrid ondatechange={ondatechange} fromDate={fromDate} toDate={toDate} onClearClick={onClearClick} onSearchClick={onSearchClick} selectedExtPartner={selectedExtPartner} onExtPartnerChange={onExtPartnerChange} extPartnerList={extPartnerList} getData={getData} rowData={data} totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} yourFunctionToUpdatePage={yourFunctionToUpdatePage} /> */}


                <div className="row" style={{
                    height: "75px",
                    marginBottom: '25px',
                    boxShadow: "0 5px 10px -2px rgba(0, 0, 0, 0.5)"
                }} >
                    <div className="col-2 d-flex align-items-center spled-container conv-zindex">
                        <div className="width-100">
                            <ReactDatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={fromDate}
                                onChange={(date) => ondatechange("fromDate", date)}
                                placeholderText="From Date"
                                minDate={new Date("01-01-2013")}
                            />
                        </div>
                    </div>

                    <div className="col-2 d-flex align-items-center spled-container conv-zindex">
                        <div className="width-100">
                            <ReactDatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={toDate}
                                onChange={(date) => ondatechange("toDate", date)}
                                placeholderText="To Date"
                                maxDate={new Date()}
                            />
                        </div>
                    </div>

                    <div className="col-6 d-flex align-items-center conv-zindex">
                        <div className="w-50">
                            <Select
                                options={extPartnerList}
                                onChange={onExtPartnerChange}
                                value={selectedExtPartner}
                                placeholder="Select Service Partner"
                            />
                        </div>
                        <div>
                            <Button style={{
                                margin: 0,
                                marginLeft: '10px',
                                height: '37px'
                            }}
                                onClick={onSearchClick}
                                // disabled={!props.selectedExtPartner}
                                className="esp-inline-button">Search</Button>
                        </div>
                        <div>
                            <Button style={{
                                margin: 0,
                                marginLeft: '10px',
                                height: '37px',
                                backgroundColor: "#eaeaea",
                                border: '2px solid #000',
                                color: "#000"
                            }}
                                onClick={onClearClick}
                                className="esp-inline-button">Clear</Button>
                        </div>

                    </div>
                    <div className="col-2 d-flex align-items-center" style={{
                        justifyContent: 'flex-end'
                    }} >
                        {
                            selectedServiceRequests.length > 0 ?
                                <Button
                                    onClick={openPaymentModalisTrue}
                                    className="esp-inline-button ml-2 mt-2" style={{
                                        marginBottom: "15px"
                                    }}>
                                    Settle Payment</Button>
                                :
                                <Button className="esp-inline-button ml-2 mt-2" style={{
                                    marginBottom: "15px",
                                    opacity: "0.4",
                                    pointerEvents: "none",
                                }}>
                                    Settle Payment</Button>

                        }
                    </div>
                </div>

                {
                    isFilterTrue &&
                    <ReactTableInvoiceGrid
                        data={data}
                        selectedServiceRequests={selectedServiceRequests}
                        onSelectServiceRequest={setSelectedServiceRequests}
                        onFetchServiceRequests={fetchServiceRequests}
                        pages={pages}
                        getServiceIDs={getServiceIDs}
                        pageSize={pageSize}
                        page={currentPage}
                        pageSizeOptions={pageSizeOptions}
                        selectedPageSizeOption={selectedPageSizeOption}
                        onPageSizeOptionChange={(option) => {
                            setSelectedPageSizeOption(option);
                        }}

                    />
                }


            </div>
        </div>
    )
}

export default PartyInvoiceMainContainer
